<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class='my-3'>
      <div class="text-xs-center">
        <h2 class="headline">エントリーが確定しました</h2>
        <span class="subheading">
          後日、確認のEメールを送信いたします。
        </span>
      </div>

<v-container grid-list-md text-xs-center>
<v-layout row wrap>
  <v-flex xs12>
          <v-divider></v-divider>
    <p style="text-align: center;margin: 25px 0px;">予約ID：{{item.id}}</p>

    <v-btn  to="/schedule" >エントリー済大会一覧へ</v-btn>
</v-flex>

</v-layout>
</v-container>
      </v-flex>



      </v-flex>
   </v-layout>
</v-container>
</template>


<script>
import firebase from 'firebase'

export default {
  components: {
    firebase
  },
  data () {
    return {
      item: Object
    }
  },
  created () {
    this.entry()
  },
  methods: {
    entry: function () {
      var db = firebase.firestore()

      // entries
      var docRef = db.collection('entries').doc(this.$route.params.id)

      // Read the document.
      docRef.get().then(doc => {
        if (doc.exists) {
          // Document read successfully.
          this.item = doc.data()
          this.item.id = doc.id
          console.log(this.item)
        } else {
          console.log('No such document!')
        }
      }).catch(function (error) {
        console.log('Error getting document:', error)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tournament/entered.vue